import { render, staticRenderFns } from "./BuKundenHerstellerUmsaetzeTabelle.vue?vue&type=template&id=fb07e21a&scoped=true&"
import script from "./BuKundenHerstellerUmsaetzeTabelle.vue?vue&type=script&lang=js&"
export * from "./BuKundenHerstellerUmsaetzeTabelle.vue?vue&type=script&lang=js&"
import style0 from "./BuKundenHerstellerUmsaetzeTabelle.vue?vue&type=style&index=0&id=fb07e21a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb07e21a",
  null
  
)

export default component.exports